import {BoosterMode} from "../services/booster.service";

export class BoosterPage {
  date: number;
  isCustom: boolean;
  mode: BoosterMode;
  id: number | 'front_page' | 'all';
  status: string;
  title: string;
  url: string;
  pagesCount: number;
}
